<template>
    <div id="olMapDiv" :style="{'left': left, 'top': top}" style="z-index:0;position:fixed;right:0;bottom:0;border: 1px solid #ccc"></div>
</template>


<script>

// mp035 require open layers
import Map from 'ol/Map.js';
import View from 'ol/View.js';
import {Draw, Modify, Snap, Select, Translate} from 'ol/interaction.js';
import {Tile as TileLayer, Vector as VectorLayer} from 'ol/layer.js';
import {OSM, Vector as VectorSource} from 'ol/source.js';
import {Circle as CircleStyle, Fill, Stroke, Style, Text, Icon} from 'ol/style.js';
//import KML from 'ol/format/KML.js';  // now unused, was used for loading local kml from files stored on server.
import Polygon from 'ol/geom/Polygon';
import Point from 'ol/geom/Point';
import Feature from 'ol/Feature';
import Overlay from 'ol/Overlay.js';
import Collection from 'ol/Collection';
import {getDistance} from 'ol/sphere';
import {transform} from 'ol/proj';

function createText(content, offsetX, offsetY){
    return new Text({
        //textAlign: undefined,
        //textBaseline: undefined,
        font: '12px sans-serif',
        text: content,
        fill: new Fill({color: "black"}),
        stroke: new Stroke({color: "black", width: 0.5}),
        offsetX: offsetX,
        offsetY: offsetY,
        placement: 'point',
        //maxAngle: maxAngle,
        //overflow: overflow,
        //rotation: rotation
    });
}

function createCommentStyle(iconSrc){
    return new Style({
        image: new Icon(/** @type {module:ol/style/Icon~Options} */ ({
            //anchor: [0.5, 46],
            anchor: [0.5, 0.0],
            anchorOrigin:'bottom-left',
            anchorXUnits: 'fraction',
            anchorYUnits: 'fraction',
            src: iconSrc
        }))
    });
}

var commentStyleGhost = createCommentStyle('/images/comment-ghost.png');
var commentStyleUnselected = createCommentStyle('/images/comment.png');
var commentStyleSelected = createCommentStyle('/images/comment-active.svg');
var commentStyleNew = createCommentStyle('/images/comment-new.svg');

function createMarker(location){
    var iconFeature = new Feature({
        geometry: new Point(location),
    });

    iconFeature.setStyle(commentStyleNew);

    return iconFeature;

}



function createPointDragInteraction(pointFeature){
    let translate = new Translate({
        features: new Collection([pointFeature])
    });
    return translate;
}

export default {
    props:{
        top: String,
        left: String,
        interactionType: String, // the current interaction type for the map.
        interactionSnap:{
            type:Boolean,
            default:false,
        },
        showNewNote:{
            type:Boolean,
            default:false,
        },
        showNotes:{ // whether comments on blocks shold be ghosted in the overview.
            type:Boolean,
            default:false,
        },
    },
    data(){
        return {
            newNoteFeature:null,
            lastViewVersion:null,
        }
    },
    mounted(){
        this.olMap = null;
        this.setupOlMap();
        this.zoomToFitSource();
        
        // Add orientation change handler
        window.addEventListener('orientationchange', this.handleOrientationChange);
    },
    beforeDestroy() {
        // Clean up event listener
        window.removeEventListener('orientationchange', this.handleOrientationChange);
    },
    methods:{
        createStyle:function(property_id){
            var property = this.$store.getters.featureById(property_id);

            if (property.type == 'note'){
                if (property.block && (! this.$store.getters.viewProperties)){
                    return commentStyleGhost;
                }
                if (property.selected){
                    return commentStyleSelected;
                }
                return commentStyleUnselected;
            }

            var fillcolor = 'rgba(200, 200, 200, 0.5)'
            var strokecolor = 'black';
            var strokewidth = 1;

            if (property.do_not_call){
                fillcolor = 'rgba(255, 128, 128, 0.5)';
                strokecolor = 'red';
            }

            if (property.selected){
                strokecolor = 'blue';
                strokewidth = 3;
            }

            if (property.structureModified){
                fillcolor = 'rgba(255, 255, 0, 0.5)';
            }

            return [
                new Style({
                fill: new Fill({
                    color: fillcolor,
                }),
                stroke: new Stroke({
                    color: strokecolor,
                    width: strokewidth,
                }),
                text: createText(property.map_text, 0,0)
                })
            ];
        },
        createNewNote: function(){
            //let location = transform(map.getView().getCenter(), 'EPSG:3857', 'EPSG:4326');
            let location = this.olMap.getView().getCenter();
            this.newNoteFeature = createMarker(location);
            this.olSource.addFeature(this.newNoteFeature);
            this.$emit('newNoteMoved', this.newNoteFeature.getGeometry().clone().transform('EPSG:3857','EPSG:4326').getCoordinates());
            this.olNoteTranslate = createPointDragInteraction(this.newNoteFeature);
            this.olMap.addInteraction(this.olNoteTranslate);
            this.olNoteTranslate.on('translateend',(e)=>{
                this.$emit('newNoteMoved', e.features.getArray()[0].getGeometry().clone().transform('EPSG:3857','EPSG:4326').getCoordinates());
            });
        },
        removeNewNote: function(){
            this.olMap.removeInteraction(this.olNoteTranslate);
            this.olSource.removeFeature(this.newNoteFeature);
        },
        clearOlMapSelection: function(){
            // reset styling of selected features before deselecting them
            this.olSelectInteraction.getFeatures().forEach((value)=>{
                if (value.propertyInfo){
                    this.$store.commit('attribute', {id:value.propertyInfo, attribute:'selected', value:false});
                    value.setStyle(this.createStyle(value.propertyInfo));
                }
            });
            this.olSelectInteraction.getFeatures().clear();
        },
        renderProperties:function(newVal){

            // clear any selected items in the interaction
            var sel = this.olSelectInteraction.getFeatures();
            //sel.clear();

            // clear other properties if they exist
            //this.olSource.clear();

            // clear all features which were in the old map, but are not in the new
            this.olSource.getFeatures().forEach(feature=>{
                if ((! newVal[feature.getId()]) && (feature != this.newNoteFeature)){
                    sel.remove(feature);
                    this.olSource.removeFeature(feature);
                }
            });

            // now add new features, and redraw those that have been modified
            Object.keys(newVal).forEach(key=>{
                var newFeature = newVal[key];

                if ((!this.showNotes) && newFeature.type == 'note'){
                    return;
                }

                var oldFeature = this.olSource.getFeatureById(key);
                if (! oldFeature){
                    // this is a new feature, so draw it in full
                    if (newFeature.type == 'note'){
                        var mapFeature = new Feature({
                            type: 'Point',
                            geometry: new Point(newFeature.location.coordinates).transform('EPSG:4326', 'EPSG:3857'),
                        });
                    } else {
                        var mapFeature = new Feature({
                            type: 'Polygon',
                            geometry: new Polygon(newFeature.geometry.coordinates).transform('EPSG:4326', 'EPSG:3857'),
                        });
                    }
                    mapFeature.setId(key);
                    mapFeature.setStyle(this.createStyle(key));
                    mapFeature.propertyInfo = newFeature.id;
                    mapFeature.set('updatedAt', newFeature.updatedAt);
                    this.olSource.addFeature(mapFeature);

                    if (newFeature.selected){
                        sel.push(mapFeature);
                    }

                } else {
                    // the feature exists so load and modify it if there are changes.
                    if (newFeature.updatedAt != oldFeature.get('updatedAt')){
                        // this feature has been changed so redraw or restyle it.

                        // first check geometries
                        if (newFeature.type == 'note'){
                            var newPointPoly = new Feature({
                                type: 'Point',
                                geometry: new Point(newFeature.location.coordinates).transform('EPSG:4326', 'EPSG:3857'),
                            });
                        } else {
                            var newPointPoly = new Feature({
                                type: 'Polygon',
                                geometry: new Polygon(newFeature.geometry.coordinates).transform('EPSG:4326', 'EPSG:3857'),
                            });
                        }

                        var newCoords = newPointPoly.getGeometry().getCoordinates();
                        var oldCoords = oldFeature.getGeometry().getCoordinates();
                        if(JSON.stringify(newCoords) != JSON.stringify(oldCoords)){
                            // regenerate the polygon.
                            oldFeature.getGeometry().setCoordinates(newCoords);
                        }

                        // if the selection attribute has changed then update the map selection
                        let inCurrentSelection = sel.getArray().find(val=>val.getId() == key);
                        if (newFeature.selected && (!inCurrentSelection)){
                            sel.push(oldFeature);
                        } else if ((!newFeature.selected) && inCurrentSelection) {
                            sel.remove(oldFeature);
                        }

                        // and always restyle the feature when it's changed
                        oldFeature.setStyle(this.createStyle(key));

                        // and record the update so it is not updated every time.
                        oldFeature.updatedAt = newFeature.updatedAt;

                    }
                }


            });
        },
        zoomToFitSource(){
            // zoom to fit map
            if (this.olSource.getFeatures().length < 1){
                // no data, so nothing to zoom to.
                return;
            }
            var extent = this.olSource.getExtent();
            this.olMap.getView().fit(extent, {
                size: this.olMap.getSize(),
                maxZoom: 19,
                duration: 1000, // animation
            });
        },
        setOlSnapInteraction:function(enabled){
            this.olMap.removeInteraction(this.olSnapInteraction);
            if (enabled){
                this.olSnapInteraction = new Snap({source: this.olSource});
                this.olMap.addInteraction(this.olSnapInteraction);
            }
        },
        setOlInteraction: function(interactionType) {



            // remove the old interaction
            this.olMap.removeInteraction(this.currentOlInteraction);

            // some interactions (move/modify) coexist with the select interaction
            // for ease of use, so we handle it separately
            this.olMap.removeInteraction(this.olSelectInteraction);

            // the select interaction on its own
            if (interactionType == "Select"){
                this.currentOlInteraction = this.olSelectInteraction;
                this.olMap.addInteraction(this.currentOlInteraction);
            } else if ( interactionType == "Move") {
                this.currentOlInteraction = new Translate({
                    //features: new Collection([pointFeature])
                    features: this.olSelectInteraction.getFeatures()
                });
                this.currentOlInteraction.on('translateend',(e)=>{
                    e.features.forEach((feature)=>{
                        if (feature.propertyInfo){
                            var storeObj = this.$store.getters.featureById(feature.propertyInfo);
                            //storeObj.structureModified = true;
                            Vue.set(storeObj, 'structureModified', true);
                            (storeObj.geometry || storeObj.location).coordinates = feature.getGeometry().clone().transform('EPSG:3857','EPSG:4326').getCoordinates();
                            this.$store.commit('feature', storeObj);
                            feature.setStyle(this.createStyle(feature.propertyInfo));
                        }
                    });
                    this.$emit('translateend', e.features);
                });

                this.olMap.addInteraction(this.currentOlInteraction);
                this.olMap.addInteraction(this.olSelectInteraction);
            } else if ( interactionType == "Modify") {
                //this.currentOlInteraction = new Modify({source: this.olSource});
                this.currentOlInteraction = new Modify({features: this.olSelectInteraction.getFeatures()});

                this.currentOlInteraction.on('modifyend',(e)=>{
                    // remove duplicate points from polygon, and mark features as modified.
                    e.features.forEach((feature)=>{

                        let remPoints = [];
                        let coords = feature.getGeometry().getCoordinates()[0];
                        coords.forEach((coord, idx)=>{
                            if (idx > 0){
                                let lastCoord = transform(coords[idx-1], 'EPSG:3857', 'EPSG:4326');
                                coord = transform(coord, 'EPSG:3857', 'EPSG:4326');
                                let dist = getDistance(coord, lastCoord);
                                if (dist < 1){
                                    if (idx == coords.length - 1){// if last point is the same as previous point, we need to remove previous point
                                        remPoints.push(idx-1);
                                    } else { // otherwise this point should be removed
                                        remPoints.push(idx);
                                    }
                                }
                            }
                        });
                        remPoints.sort(function(a, b){return b-a}); // sort descending
                        for (var i = 0; i < remPoints.length; i++){
                            if (coords.length <= 4) break;
                            if (remPoints[i] < coords.length){
                                coords.splice(remPoints[i], 1);
                            }
                        }
                        feature.getGeometry().setCoordinates([coords]);

                        if (feature.propertyInfo){
                            var storeObj = this.$store.getters.featureById(feature.propertyInfo);
                            //storeObj.structureModified = true;
                            Vue.set(storeObj, 'structureModified', true);
                            storeObj.geometry.coordinates = feature.getGeometry().clone().transform('EPSG:3857','EPSG:4326').getCoordinates();
                            this.$store.commit('feature', storeObj);
                            feature.setStyle(this.createStyle(feature.propertyInfo));
                        }

                    });
                    // after the polygon is cleaned, emit an event to indicate the modify is complete
                    this.$emit('modifyend', e.features);
                });
                // modify and select coexist for ease of use.
                this.olMap.addInteraction(this.currentOlInteraction);
                this.olMap.addInteraction(this.olSelectInteraction);

            } else {// polygon etc.
                this.clearOlMapSelection();
                this.currentOlInteraction = new Draw({
                    source: this.olSource,
                    type: interactionType
                });

                this.currentOlInteraction.on('drawend', (event)=> {
                    var feature = event.feature;
                    this.$emit('drawend', event.feature);
                });
                this.olMap.addInteraction(this.currentOlInteraction);
            }

            // the snap feature needs to be recreated whenever source or interaction is changed
            // so recreate it here if required
            this.setOlSnapInteraction(this.interactionSnap);

        },

        setupOlMap: function(){

            // if the map already exists, then
            // just populate it
            if (this.olMap){
                this.renderProperties(this.$store.getters.currentFeatures);
                return;
            }
/*
            if (this.$store.getters.currentFeatures.length < 1){
                // no data, so don't bother trying to
                // setup the map.
                return;
            }
*/
            var raster = new TileLayer({
                source: new OSM()
            });

            this.olSource = new VectorSource();
            var vector = new VectorLayer({
                source: this.olSource,
                style: new Style({
                    fill: new Fill({
                        color: 'rgba(255, 255, 255, 0.5)'
                    }),
                    stroke: new Stroke({
                        color: '#000000',
                        width: 2
                    }),
                    // TODO: try removing the image attribute to see what it does.
                    image: new CircleStyle({
                        radius: 7,
                        fill: new Fill({
                            color: '#ffcc33'
                        })
                    })
                })
            });

            this.olMap = new Map({
                layers: [raster, vector/*, kml*/],
                target: 'olMapDiv',
                view: new View({
                    //center: [-11000000, 4600000],
                    center: transform([133.7751,-25.2744], 'EPSG:4326', 'EPSG:3857'),
                    zoom: 4
                })
            });

            this.olSelectInteraction = new Select();
            this.olSelectInteraction.on('select', (e) => {
                e.selected.forEach((value)=>{
                    if (value.propertyInfo){
                        // for blocks and properties
                        this.$store.commit('attribute', {id:value.propertyInfo, attribute:'selected', value:true});
                        //value.setStyle(this.createStyle(value.propertyInfo));
                    } else {
                        // for comments
                        value.setStyle(commentStyleSelected);
                    }
                });
                e.deselected.forEach((value)=>{
                    if (value.propertyInfo){
                        // for blocks and properties
                        this.$store.commit('attribute', {id:value.propertyInfo, attribute:'selected', value:false});
                        value.setStyle(this.createStyle(value.propertyInfo));
                    }
                });

                if (e.target.getFeatures().getLength() == 1){


                    var value = e.target.getFeatures().item(0);

                    var coordinates = value.getGeometry().getCoordinates();
                    this.$emit('singleFeatureSelected', value);

                } else if (e.target.getFeatures().getLength() > 1) {
                    this.$emit('multiFeatureSelected', e.target.getFeatures());
                } else {
                    this.$emit('noFeatureSelected');
                }
            });
            this.olMap.addInteraction(this.olSelectInteraction);

            this.setOlInteraction(this.interactionType);

            // render the property polygons after the map is created.
            this.renderProperties(this.$store.getters.currentFeatures);
        },
        handleOrientationChange: function() {
            // Force a resize of the map to handle orientation change
            if (this.olMap) {
                this.olMap.updateSize();
            }
        },
    },
    computed:{
        currentFeatures(){
            return this.$store.getters.currentFeatures;
        },
        viewVersion(){
            return this.$store.getters.view;
        }

    },
    watch: {
        currentFeatures:{
            handler:function(newVal /*oldval does not work on deep watches*/){
                this.renderProperties(newVal);
            },
            deep:true,
        },
        viewVersion(){
            this.zoomToFitSource();
        },
        interactionType: function(newVal, oldVal){
            this.setOlInteraction(newVal);
        },
        interactionSnap: function(newVal, oldVal){
            this.setOlSnapInteraction(newVal);
        },
        showNewNote: function(newVal, oldVal){
            if (newVal){
                this.createNewNote();
            } else {
                this.removeNewNote();
            }
        }
    }

}
</script>

